export const ellipsize = {
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis'
}

export const underline = {
  textDecoration: 'underline',
  textDecorationSkip: 'ink'
}
